
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/beginner-intro",
      function () {
        return require("private-next-pages/guide/beginner-intro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/beginner-intro"])
      });
    }
  